export interface FormFieldProps<V> extends FormFieldValueProps<V> {
  disabled?: boolean;
  placeholder?: string;
  required?: boolean;
}

export interface FormFieldValueProps<V> {
  defaultValue?: V;

  onValue?(value: V): void;

  value?: V;
}

export type ValuePropKeys<V> = keyof FormFieldValueProps<V>;

export function extractValueProps<V, T extends FormFieldProps<V>>(props: T): [Pick<T, ValuePropKeys<V>>, Omit<T, ValuePropKeys<V>>] {
  const { defaultValue, onValue, value, ...remainingProps } = props;
  return [{ defaultValue, onValue, value }, remainingProps];
}
